export const environment = {
	production: true,
	apiUrl: '/api',
  pusherKey: 'scap897079688e2xx04dff4b23613228',
  loggingLevel: 0,
	sentryDSN: null,
		socketUrl: "okaju.beta.modesk.io",

	CLOUD_URL: null,
};
